<!--
<div class="row">
    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
        <h2 class="mt-5px">Sub Admins</h2>
    </div>
    <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
        <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                (click)="showSearch = !showSearch">
            <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
        </button>
        <button class="btn btn-primary pull-right color-white color-white users-btn mr-2 cursor-pointer"
                (click)="add()">
            <i aria-hidden="true" class="fa fa-plus-circle mr-8px"></i>&nbsp;Add SubAdmin
        </button>
    </div>
</div>
<div class="row search-card mt-3" *ngIf="showSearch">
    <div class="col-12">
        <form class="form mt-2 mb&#45;&#45;8px" novalidate [formGroup]="searchForm">
            <div class="row">
                <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                    <fieldset class="form-group">
                        <input class="form-control" type="text" id="name" formControlName="name" placeholder="Name">
                    </fieldset>
                </div>
                <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                    <fieldset class="form-group">
                        <input class="form-control" type="text" id="name" formControlName="username"
                               placeholder="Username">
                    </fieldset>
                </div>
                <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                    <fieldset class="form-group">
                        <input class="form-control" id="name" type="text" formControlName="email" placeholder="Email">
                    </fieldset>
                </div>
                <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                    <fieldset class="form-group">
                        <input class="form-control" type="number" id="name" formControlName="contact"
                               placeholder="Contact">
                    </fieldset>
                </div>
                <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12 text-center">
                    <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                            (click)="search()"
                            [disabled]="submitting">
                        <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>
<div class="container mt-3">
    <table class="table table-striped">
        <thead>
        <div class="row d-none d-md-block mt-3">
            <div class="col-12">
                <div class="card">
                    <div class="container-fluid">
                        <div class="row overflow-x-scroll overflow-table">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <table class="table table-list text-center">
                                    <thead>
                                    <tr>
                                        <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                        </th>
                                        <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Name</h6>
                                        </th>
                                        <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Username</h6>
                                        </th>
                                        <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Email</h6>
                                        </th>
                                        <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Contact</h6>
                                        </th>
                                        <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Password</h6>
                                        </th>
                                        <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let subAdmins of subAdmin ">
                                        <td class="text-center"><h6> {{details?.SNO}}</h6></td>
                                        <td class="text-center"><h6 class="mt-1">{{details?.Name}}</h6></td>
                                        <td class="text-center"><h6 class="mt-1">{{details?.Username}}</h6></td>
                                        <td class="text-center"><h6 class="mt-1">{{details?.email}}</h6></td>
                                        <td class="text-center"><h6 class="mt-1">{{details?.contact}}</h6></td>
                                        <td class="text-center cursor-pointer">
                                            <h6 class="mt-1 text-info"
                                                (click)="updatePasswordModal(content, admin.id)">
                                                Update</h6>
                                        </td>
                                        <td class="text-center">
                                            <i aria-hidden="true"
                                               class="fas fa-edit f_20 ml-5px text-info cursor-pointer font-weight-light mt-1"
                                               title="Edit" (click)="edit(admin)"></i>
                                            <i aria-hidden="true"
                                               class="fas fa-lock f_20 ml-5px text-danger cursor-pointer mt-1"
                                               title="In Active Admin"
                                            ></i>

                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                                <core-sidebar
                                        class="modal modal-slide-in sidebar-todo-modal fade"
                                        name="add-sub-admin"
                                        overlayClass="modal-backdrop">
                                    <app-add-sub-admin [data]="data"
                                                       (valueSubmitted)="getData($event)"></app-add-sub-admin>
                                </core-sidebar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </thead>
    </table>
</div>

-->

<div class="content-wrapper">
    <div class="content-body">
        <section id="subAdmins">
            <ng-template #content>
                <div id="modal">
                    <div class="modal-header font-weight-bold">
                        <h4 class="modal-title font-weight-bold">Update Password</h4>
                        <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                (click)="modalService.dismissAll('')"
                        >
                            ×
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <form class="form" novalidate [formGroup]="updatePasswordForm">
                                    <div class="px-3 container">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="password" class="d-flex">
                                                        Password
                                                        <i (click)="inputTypePassword = 'text'"
                                                           [ngClass]="{'display-hidden': (inputTypePassword === 'text')}"
                                                           class="fas fa-eye-slash d-flex align-items-center pl-1 cursor-pointer"></i>
                                                        <i (click)="inputTypePassword = 'password'"
                                                           [ngClass]="{'display-hidden': (inputTypePassword === 'password')}"
                                                           class="fas fa-eye d-flex align-items-center pl-1  cursor-pointer"></i>
                                                    </label>
                                                    <input class="form-control" id="password" [type]="inputTypePassword"
                                                           formControlName="password">
                                                    <small *ngIf="submitted && updatePasswordForm.get('password').hasError('required')"
                                                           class="text-danger">
                                                        Field is required.
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-success color-white pull-right" [disabled]="submitting"
                                (click)="updatePassword()">
                            <i class="fas fa-pen-square mr-1" *ngIf="!submitting"></i>
                            <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Update
                        </button>
                    </div>
                </div>
            </ng-template>
            <div class="row">
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <h2 class="mt-5px">Sub Admins</h2>
                </div>
                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2"
                            (click)="showSearch = !showSearch">
                        <i aria-hidden="true" class="fa fa-search mr-8px"></i>&nbsp;Search
                    </button>
                    <button class="btn btn-primary pull-right color-white color-white users-btn mr-2 cursor-pointer"
                            (click)="add()">
                        <i aria-hidden="true" class="fa fa-plus-circle mr-8px"></i>&nbsp;Add SubAdmin
                    </button>
                </div>
            </div>
            <div class="row search-card mt-3" *ngIf="showSearch">
                <div class="col-12">
                    <form class="form mt-2 mb--8px" novalidate [formGroup]="searchForm">
                        <div class="row">
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="name" placeholder="Name">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="username"
                                           placeholder="Username">
                                </fieldset>
                            </div>
                            <div class="col-md-3 col-lg-3 col-sm-3 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="text" formControlName="email" placeholder="Email">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12">
                                <fieldset class="form-group">
                                    <input class="form-control" type="number" formControlName="contact"
                                           placeholder="Contact">
                                </fieldset>
                            </div>
                            <div class="col-md-2 col-lg-2 col-sm-2 col-xs-12 text-center">
                                <button class="btn btn-primary btn-block btn-raised color-white mr-2 users-btn"
                                        (click)="search()"
                                        [disabled]="submitting">
                                    <i class="fas fa-spinner fa-pulse mr-1" *ngIf="submitting"></i>Search
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row d-none d-md-block mt-3">
                <div class="col-12">
                    <div class="card">
                        <div class="container-fluid">
                            <div class="row overflow-x-scroll overflow-table">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <table class="table table-list text-center">
                                        <thead>
                                        <tr>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">S.No</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Name</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Username</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Email</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Contact</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Password</h6>
                                            </th>
                                            <th class="text-center"><h6 class="mt-1 mb-1 font-weight-bold">Action</h6>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody *ngIf="subAdmins && subAdmins.length > 0; else noDataToShowWeb">
                                        <tr *ngFor="let subAdmin of subAdmins; let i = index">
                                            <td class="text-center">
                                                <h6 class="mt-1">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                                    .</h6>
                                            </td>
                                            <td class="text-center"><h6 class="mt-1">{{subAdmin?.name}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{subAdmin?.username}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{subAdmin?.email}}</h6></td>
                                            <td class="text-center"><h6 class="mt-1">{{subAdmin?.contact}}</h6></td>
                                            <td class="text-center cursor-pointer">
                                                <h6 class="mt-1 text-info"
                                                    (click)="updatePasswordModal(content, subAdmin.id)">
                                                    Update</h6>
                                            </td>
                                            <td class="text-center">
                                                <i aria-hidden="true"
                                                   class="fas fa-edit f_20 ml-5px text-info cursor-pointer font-weight-light mt-1"
                                                   title="Edit" (click)="edit(subAdmin)"></i>
                                                <i aria-hidden="true"
                                                   class="fas fa-lock f_20 ml-5px text-danger cursor-pointer mt-1"
                                                   title="In Active Admin"></i>
                                                <i aria-hidden="true"
                                                   class="fas fa-lock-open f_20 ml-5px text-success cursor-pointer mt-1"
                                                   title="Active Admin" *ngIf="subAdmin?.status === 'INACTIVE'"
                                                   (click)="updateStatus('ACTIVE', subAdmin)"></i>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <ng-template #noDataToShowWeb>
                                            <tbody>
                                            <tr>
                                                <td colspan="7" class="text-center"><h6>No data to show</h6></td>
                                            </tr>
                                            </tbody>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3 d-block d-md-none" *ngIf="subAdmins && subAdmins.length > 0; else noDataToShowMobile">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="card" *ngFor="let subAdmins of subAdmin; let i = index">
                        <div class="card-header bottom-shadow-light pb-18px">
                            <div class="row width-100-per">
                                <div class="col-6">
                                    <h4
                                            class="card-title text-uppercase card-ellipsis">{{(pagination.page - 1) * (pagination.perpage ? pagination.perpage : 0) + i + 1}}
                                        . {{subAdmin?.name}}</h4>
                                </div>
                                <div class="col-6">
                                    <i aria-hidden="true"
                                       class="fas fa-lock f_20 ml-1 text-danger cursor-pointer pull-right"
                                       title="In Active Executive" *ngIf="subAdmin?.status === 'ACTIVE'"
                                       (click)="updateStatus('INACTIVE', subAdmin)"></i>
                                    <i aria-hidden="true"
                                       class="fas fa-lock-open ml-1 f_20 text-success cursor-pointer pull-right"
                                       title="Active Executive" *ngIf="subAdmin?.status === 'INACTIVE'"
                                       (click)="updateStatus('ACTIVE', subAdmin)"></i>
                                    <i aria-hidden="true"
                                       class="fas fa-edit f_20 text-info cursor-pointer font-weight-light pull-right"
                                       title="Edit" (click)="edit(subAdmin)"></i>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row p-2">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Username - {{subAdmin?.username}}
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Email - {{subAdmin?.email}}
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Contact - {{subAdmin?.contact}}
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-1">
                                    Password - <span class="text-info" (click)="updatePasswordModal(content, subAdmin.id)">Update</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #noDataToShowMobile>
                <div class="row mt-3 d-block d-md-none">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="card text-center">
                            <h5 class="p-5">No data to show</h5>
                        </div>
                    </div>
                </div>
            </ng-template>
            <div class="row pagination-table">
                <ngb-pagination class="pagination-primary" [collectionSize]="pagination.total"
                                [(page)]="pagination.page" [boundaryLinks]="true"
                                [pageSize]="pagination.perpage" [maxSize]="5"
                                (pageChange)="onPageChange($event)">
                    <ng-template ngbPaginationPrevious>
                        <span [data-feather]="'chevron-left'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                    <ng-template ngbPaginationNext>
                        <span [data-feather]="'chevron-right'" [size]="18"
                              [class]="'font-weight-bolder'">
                        </span>
                    </ng-template>
                </ngb-pagination>
            </div>
        </section>
    </div>
    <core-sidebar
            class="modal modal-slide-in sidebar-todo-modal fade"
            name="add-sub-admin"
            overlayClass="modal-backdrop">
        <app-add-sub-admin [data]="data" (valueSubmitted)="getData($event)"></app-add-sub-admin>
    </core-sidebar>
</div>

